'use es6';

import * as CacheKeys from 'reference-resolvers/constants/CacheKeys';
import { getAllSavedFilters, createGetAllSavedFilters } from 'reference-resolvers/api/SavedFiltersAPI';
import createSimpleCachedReferenceResolver from 'reference-resolvers/lib/createSimpleCachedReferenceResolver';
export const createDealsSavedFiltersReferenceResolver = options => createSimpleCachedReferenceResolver(Object.assign({
  cacheKey: CacheKeys.DEALS_SAVED_FILTERS,
  createFetchData: opts => createGetAllSavedFilters(opts)('deals'),
  fetchData: getAllSavedFilters('deals')
}, options));
export default createDealsSavedFiltersReferenceResolver();